<ion-app (contextmenu)="rightCLick($event)" [class.dark-theme]="dark" [class.has-mobile-tabs]="showMobileTabs()">
	<a class="skip-link" href="#main-content">Skip to main content</a>
	@if (showMenu()) {
		<app-menu></app-menu>
	}
	<main id="main-content">
		<ion-router-outlet id="root-content"></ion-router-outlet>
	</main>
	@if (showMobileTabs()) {
		<app-mobile-tab-bar></app-mobile-tab-bar>
	}
</ion-app>
